"use client";
import React, { useEffect, useState } from "react";
import $ from "jquery";
import { useNavigate } from "react-router-dom";
import {
  userWalletData,
  userPoint,
  addWalletMoney,
} from "../../../../services/billing";
import Breadcrumb from "../../../../utility/breadcrumb/Breadcrumb";
import { useRazorpay } from "../../../../context/RazorpayContext";
import RazorpayModal from "../Razorpay/RazorpayModal";

const WalletDashboard = () => {
  const [wallet, setWallet] = useState(null);
  const [transactions, setTransactions] = useState([]);
  const [points, setPoints] = useState(null);
  const [amount, setAmount] = useState("");
  const navigate = useNavigate();
  const { handleAddFunds, razorpayModalData } = useRazorpay();
  const afterPaymentSuccessNavigationUrl = "/billing-section";

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const [walletRes, pointsRes] = await Promise.all([
        userWalletData(),
        userPoint(),
      ]);
      const walletData = walletRes?.data?.data;
      setWallet(walletData?.wallet);
      setTransactions(walletData?.transactions || []);
      setPoints(pointsRes?.data?.data);
    } catch (err) {
      console.error("API Error:", err);
    }
  };
  useEffect(() => {
    if ($.fn.DataTable.isDataTable("#transactions-table")) {
      $("#transactions-table").DataTable().destroy();
    }

    if (transactions?.length > 0) {
      $("#transactions-table").DataTable({
        pageLength: 10,
        ordering: true,
        searching: true,
        lengthMenu: [10, 25, 50, 100, 200, 500],

        dom:
          '<"row custom_data_filter_col"' +
          '<"col-6 custom_datatable"f>' +
          '<"col-6 text-end d-flex justify-content-end align-items-center gap-2"B>>' +
          '<"table-responsive"t>' +
          '<"row mgltm0"' +
          '<"col-sm-5 show-entry"li>',

        buttons: [
          {
            extend: "copy",
            text: '<i class="bi bi-clipboard"></i>',
            titleAttr: "COPY",
          },
          {
            extend: "csv",
            text: '<i class="bi bi-filetype-csv"></i>',
            titleAttr: "CSV",
          },
          {
            extend: "pdf",
            text: '<i class="bi bi-filetype-pdf"></i>',
            titleAttr: "PDF",
          },
          {
            extend: "print",
            text: '<i class="bi bi-printer"></i>',
            titleAttr: "PRINT",
          },
        ],

        language: {
          paginate: {
            previous: '<i class="bi bi-chevron-left"></i>',
            next: '<i class="bi bi-chevron-right"></i>',
          },

          search: "",
        },
      });
    }

    return () => {
      if ($.fn.DataTable.isDataTable("#transactions-table")) {
        $("#transactions-table").DataTable().destroy();
      }
    };
  }, [transactions]);

  const getWalletStatus = (balance = "₹0") => {
    if (balance >"₹3000") return "good";
    if (balance > "₹1000") return "medium";
    return "low";
  };

  const getWalletMessage = (balance = "₹0") => {
    if (balance > "₹3000") return "Your wallet balance is healthy";
    if (balance > "₹1000") return "Your wallet balance is moderate";
    return "Low wallet balance. Please add funds.";
  };


  return (
    <>
      {razorpayModalData?.isRazorPayModal && (
        <RazorpayModal navigationUrl={afterPaymentSuccessNavigationUrl} />
      )}
      <div className="without-datepicker-breadcrumb">
        <Breadcrumb />
      </div>
      <div className="wallet-page">
        <div className="wallet-grid">
          {/* WALLET CARD */}
          <div className="card wallet-card">
            <p className="card-title">WALLET DETAILS</p>

            <div className="wallet-header-row">
              <div>
                <h1 className="balance">{wallet?.balance || 0}</h1>
                <div className="label">Balance</div>
              </div>
              <div
                className="wallet-icon"
                style={{ color: "var(--actionable-active-color)", opacity: 1 }}
              >
                <i className="bi bi-wallet2"></i>
              </div>
            </div>

            <div className={`wallet-alert ${getWalletStatus(wallet?.balance)}`}>
              {getWalletMessage(wallet?.balance)}
            </div>

            <div
              className="points-box clickable"
              onClick={() => navigate("/billing-section/points")}
              title="Click to manage points"
            >
              <div className="d-flex justify-content-between align-items-center">
                <span>
                  <i className="bi bi-star-fill text-warning me-1"></i>{" "}
                  {Number(points?.balance || 0).toLocaleString("en-IN")} pts
                </span>
                <i
                  className="bi bi-chevron-right"
                  style={{ fontSize: "12px", opacity: 0.7 }}
                ></i>
              </div>
              <p
                style={{
                  marginTop: "8px",
                  fontSize: "12px",
                  lineHeight: "1.4",
                }}
              >
                {points?.balance > 0
                  ? "Points are used for premium insights. Buy more points to explore."
                  : "You have no points yet. Buy points to access premium features!"}
              </p>
            </div>
          </div>

          {/* TOPUP */}
          <div className="card topup-card">
            <p className="card-title">PAYMENT & TOP-UP</p>

            <div className="topup-box">
              <div className="topup-header">
                <span>TOP-UP</span>
                <span style={{ color: "var(--actionable-active-color)" }}>
                  <i className="bi bi-wallet2"></i>
                </span>
              </div>

              <div className="input-box">
                <input
                  type="number"
                  min="1"
                  placeholder="Enter Amount"
                  value={amount}
                  onChange={(e) => {
                    const val = e.target.value;
                    // Only allow digits, prevent leading zeros unless it's just an empty string
                    if (val === "" || /^[1-9][0-9]*$/.test(val)) {
                      setAmount(val);
                    }
                  }}
                />
                <span className="currency">₹</span>
              </div>

              <div className="quick-amounts">
                {[500, 1000, 5000].map((amt) => (
                  <button
                    key={amt}
                    onClick={() => setAmount(String(amt))}
                    className={Number(amount) === amt ? "active" : ""}
                  >
                    ₹{amt}
                  </button>
                ))}
              </div>

              <button
                disabled={!amount || Number(amount) <= 0}
                className="pay-btn"
                onClick={(e) => handleAddFunds(e, amount)}
              >
                Add Funds +
              </button>

              <p className="secure-text">
                <i className="bi bi-lock-fill me-1"></i> Secure payments powered
                by Razorpay
              </p>
            </div>
          </div>
        </div>

        {/* TRANSACTIONS */}
        <div className="card transaction-card modern-transaction-card">
          <div className="transaction-header">
            <div className="kpi-heading">Recent Transaction</div>
            {/* <button className="view-btn">View All</button> */}
          </div>

          <div className="table-responsive">
            <table
              id="transactions-table"
              // className="display table transaction-table"
              style={{ width: "100%" }}
            >
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Date</th>
                  <th>Type</th>
                  <th>Description</th>
                  <th>Amount</th>
                </tr>
              </thead>

              <tbody>
                {transactions?.map((tx, i) => (
                  <tr key={i}>
                    <td>{tx.id}</td>

                    <td>
                      {tx.date
                        ? new Date(tx.date).toLocaleDateString("en-GB")
                        : "-"}
                    </td>

                    <td style={{ textTransform: "capitalize" }}>
                      <span
                        className={`transaction-badge ${
                          tx.type === "credit" ? "credit-badge" : "debit-badge"
                        }`}
                      >
                        {tx.type}
                      </span>
                    </td>

                    <td>{tx.description}</td>

                    <td
                      className={
                        tx.type === "credit"
                          ? "credit amount-text"
                          : "debit amount-text"
                      }
                    >
                      {tx.amount}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {transactions?.length === 0 && (
            <p className="no-data">No transactions available</p>
          )}
        </div>
      </div>
    </>
  );
};

export default WalletDashboard;
